import { useSelector } from 'react-redux';

import { getUserRoleIsSupervisor } from '../../../AuthPackage/MainModule/selectors/authSelectors';
import {
  getChangePlanReasonAfterConfirmEvent,
  getKnmDataErknmApproveAppeal,
  getKnmDataErknmApproveApproved,
  getKnmDataErknmIsPlanned,
  getKnmIsCommonWatchOnly,
  getKnmIsEditableInStatusCommentsExist,
  getKnmIsErknmStatusCommentsExist,
  getKnmIsErknmStatusFillInProcess,
  getKnmIsErknmStatusReadyForApprove,
  getKnmIsErknmStatusTypeWaitingCarryOut,
} from '../../../KnmPackage/MainModule/selectors/knmSelectors';
import { getPlanListPlanErknmStatus } from '../../../PlanListPackage/MainModule/selectors/planListSelectors';
import { getIsPlanErknmStatusConsidered } from '../../../APIPackage/PlanListModule/common/getPlanErknmStatusFlags';
import { useHasFieldApproveRemark } from '../common/useHasFieldApproveRemark';
import { ErknmApproveRemarkSectionCodeEnum } from '../../ErknmApproveRemarkModule/enums/ErknmApproveRemarkSectionCodeEnum';
import { ApprovedTypesEnum } from '../../../APIPackage/KnmModule/enums/ApprovedTypesEnum';

export const useIsChecklistEnabled = () => {
  const isSupervisor = useSelector(getUserRoleIsSupervisor);
  const isCommonWatchOnly = useSelector(getKnmIsCommonWatchOnly);
  const isKnmStatusFillInProcess = useSelector(getKnmIsErknmStatusFillInProcess);
  const isKnmStatusReadyForApprove = useSelector(getKnmIsErknmStatusReadyForApprove);
  const isEditableInStatusCommentsExist = useSelector(getKnmIsEditableInStatusCommentsExist);
  const knmPlanStatus = useSelector(getPlanListPlanErknmStatus);
  const knmDataApproved = useSelector(getKnmDataErknmApproveApproved);
  const isKnmDataApproveAppeal = useSelector(getKnmDataErknmApproveAppeal);
  const isKnmStatusCommentsExist = useSelector(getKnmIsErknmStatusCommentsExist);
  const isKnmPlanStatusConsidered = getIsPlanErknmStatusConsidered(knmPlanStatus);
  const isChecklistsRemarksExists = useHasFieldApproveRemark(ErknmApproveRemarkSectionCodeEnum.CHECKLISTS);
  const isKindKnmRemarksExists = useHasFieldApproveRemark(ErknmApproveRemarkSectionCodeEnum.KIND_KNM);
  const isDatesRemarksExists = useHasFieldApproveRemark(ErknmApproveRemarkSectionCodeEnum.DATES);
  const isReasonsRemarksExists = useHasFieldApproveRemark(ErknmApproveRemarkSectionCodeEnum.REASONS);
  const isObjectsRemarksExists = useHasFieldApproveRemark(ErknmApproveRemarkSectionCodeEnum.OBJECTS);
  const changePlanReasonAfterConfirm = useSelector(getChangePlanReasonAfterConfirmEvent);
  const isPlanned = useSelector(getKnmDataErknmIsPlanned);
  const isKnmStatusTypeWaitingCarryOut = useSelector(getKnmIsErknmStatusTypeWaitingCarryOut);

  const isActiveFieldPlanConsideredWithApprovedAppeal =
    knmDataApproved === ApprovedTypesEnum.APPROVED && !!isKnmDataApproveAppeal && isKnmPlanStatusConsidered;

  const isCheckForRsnChngPpXXII = changePlanReasonAfterConfirm?.some(
    item => item?.reasonChangeType?.code === 'RSN_CHNG_PP_XXII',
  );

  return (
    !isCommonWatchOnly &&
    isSupervisor &&
    (isKnmStatusFillInProcess ||
      isKnmStatusReadyForApprove ||
      isActiveFieldPlanConsideredWithApprovedAppeal ||
      isEditableInStatusCommentsExist ||
      (isKnmStatusCommentsExist &&
        isKnmPlanStatusConsidered &&
        (isChecklistsRemarksExists ||
          isKindKnmRemarksExists ||
          isDatesRemarksExists ||
          isReasonsRemarksExists ||
          isObjectsRemarksExists)) ||
      (isKnmStatusTypeWaitingCarryOut && isPlanned && isCheckForRsnChngPpXXII))
  );
};
